import { Egg, Milk, Carrot, Apple, Snowflake, Drumstick, ShoppingBasket, Droplets, Wheat, Beef, Nut, Cookie, Fish } from "lucide-react";

const MAP = {
  eggs: Egg,
  egg: Egg,
  milk: Milk,
  curd: Milk,
  paneer: Milk,
  dairy: Milk,
  vegetables: Carrot,
  vegetable: Carrot,
  veggies: Carrot,
  fruits: Apple,
  fruit: Apple,
  "frozen foods": Snowflake,
  frozen: Snowflake,
  chicken: Drumstick,
  meat: Beef,
  mutton: Beef,
  fish: Fish,
  seafood: Fish,
  grocery: ShoppingBasket,
  groceries: ShoppingBasket,
  oils: Droplets,
  oil: Droplets,
  ghee: Droplets,
  atta: Wheat,
  rice: Wheat,
  flour: Wheat,
  grains: Wheat,
  peanuts: Nut,
  nuts: Nut,
  dryfruits: Nut,
  snacks: Cookie,
  biscuits: Cookie,
};

export const iconForCategory = (name) => MAP[(name || "").trim().toLowerCase()] || ShoppingBasket;
